import React, { useState } from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { dropDownSelectStyle } from '../ReusableStyles/CommonStyles';
import ReplayIcon from '@mui/icons-material/Replay';
interface SlidingOptionsProps {
  windowFnValues: any;
  setWindowFnValues: (fn: (prev: any) => any) => void;
  slidingAggregation: string[];
  textFieldStyleProps: any;
  muiOutlinedInputStyle: any;
  radioButton: any;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SlidingOptions: React.FC<SlidingOptionsProps> = ({
  windowFnValues,
  setWindowFnValues,
  slidingAggregation,
  textFieldStyleProps,
  muiOutlinedInputStyle,
  radioButton,
  handleKeyDown,
}) => {
  const dropdownSelections = {
    first:
      windowFnValues.slidingPreInc < 0
        ? 'Previous'
        : windowFnValues.slidingPreInc === 0
          ? 'Current'
          : 'Next',
    second:
      windowFnValues.slidingNextInc === undefined || windowFnValues.slidingNextInc === 0
        ? 'Current'
        : windowFnValues.slidingNextInc < 0
          ? 'Previous'
          : 'Next',
  };
  const absPrev = Math.abs(windowFnValues.slidingPreInc ?? 10);
  const absNext = windowFnValues.slidingNextInc ? Math.abs(windowFnValues.slidingNextInc) : 10;
  const [isCustomSelected, setIsCustomSelected] = useState({
    first: Math.abs(absPrev) > 5 && Math.abs(absPrev) !== 999,
    second: !!windowFnValues.slidingNextInc && Math.abs(absNext) > 5 && Math.abs(absNext) !== 999,
  });

  const [inputs, setInputs] = useState({
    first: absPrev !== 999 ? absPrev.toString() : '10',
    second: absNext && absNext !== 999 ? absNext.toString() : '10',
  });
  const needSecondRef = windowFnValues.slidingNextInc !== undefined;
  const dropDownOptions = ['Previous', 'Current', 'Next'] as const;
  const values = [
    { label: 'All', value: '999' },
    { label: '1st', value: '1' },
    { label: '2nd', value: '2' },
    { label: '3rd', value: '3' },
    { label: '4th', value: '4' },
    { label: '5th', value: '5' },
    { label: 'Custom', value: 'Custom' },
  ];
  const resetWindowFunction = () => {
    setWindowFnValues((prevState: any) => ({
      ...prevState,
      slidingPreInc: -999,
      slidingNextInc: 0,
    }));
    setIsCustomSelected({ first: false, second: false });
  };
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const { name, value } = event.target;
    setInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;

    const prev = windowFnValues.slidingPreInc;
    const next = windowFnValues.slidingNextInc;
    if (value === 'Current') {
      const isOtherCurrent = name !== 'first' ? prev === 0 : next === 0;
      setWindowFnValues((prevState: any) => ({
        ...prevState,
        [name === 'first' ? 'slidingPreInc' : 'slidingNextInc']: 0,
        ...(isOtherCurrent && {
          [name !== 'first' ? 'slidingPreInc' : 'slidingNextInc']: -999,
        }),
      }));
    } else {
      let modifiedInput = name === 'first' ? prev || 999 : next || 999;
      modifiedInput = value === 'Previous' ? -Math.abs(modifiedInput) : Math.abs(modifiedInput);

      setWindowFnValues((prevState: any) => ({
        ...prevState,
        [name === 'first' ? 'slidingPreInc' : 'slidingNextInc']: modifiedInput,
      }));
    }
  };
  const handleInputChange = (event: React.FocusEvent<HTMLInputElement>) => {
    event.preventDefault();
    const { name } = event.target;
    const value = inputs[name as keyof typeof inputs] ?? '10';
    let modifiedInput = value === '' ? 1 : Number(value);
    if (modifiedInput > 100) modifiedInput = 100;
    if (modifiedInput < 1) modifiedInput = 1;
    modifiedInput =
      dropdownSelections[name as keyof typeof dropdownSelections] === 'Previous'
        ? -Math.abs(modifiedInput)
        : Math.abs(modifiedInput);

    setWindowFnValues((prevState: any) => ({
      ...prevState,
      [name === 'first' ? 'slidingPreInc' : 'slidingNextInc']: modifiedInput,
    }));
    setInputs((prev) => ({
      ...prev,
      [name]: Math.abs(modifiedInput).toString(),
    }));
  };
  const handleDropdownChangeForRow = (event: SelectChangeEvent<string>) => {
    event.preventDefault();
    const { name, value } = event.target;
    if (value === 'Custom') {
      setIsCustomSelected((prev) => ({
        ...prev,
        [name]: true,
      }));
      let modifiedInput = 50;
      modifiedInput =
        dropdownSelections[name as keyof typeof dropdownSelections] === 'Previous'
          ? Math.abs(modifiedInput) * -1
          : modifiedInput;
      setWindowFnValues((prevState: any) => ({
        ...prevState,
        [name === 'first' ? 'slidingPreInc' : 'slidingNextInc']: modifiedInput,
      }));
    } else {
      let modifiedInput = Number(value);
      modifiedInput =
        dropdownSelections[name as keyof typeof dropdownSelections] === 'Previous'
          ? Math.abs(modifiedInput) * -1
          : modifiedInput;

      setWindowFnValues((prevState: any) => ({
        ...prevState,
        [name === 'first' ? 'slidingPreInc' : 'slidingNextInc']: modifiedInput,
      }));
    }
  };

  const handleNeedOFSecondRefChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    const prev = windowFnValues.slidingPreInc;
    setWindowFnValues((prevState: any) => ({
      ...prevState,
      ['slidingNextInc']: checked ? (prev === 0 ? 999 : 0) : undefined,
    }));
  };
  return (
    <div style={{ width: '100%' }}>
      <div className="MenuSize" style={{ width: '100%' }}>
        <Typography
          sx={{
            fontSize: '12px',
            paddingLeft: '15px',
            fontWeight: 'bold',
            color: 'primary.main',
          }}
        >
          Moving Calculation
        </Typography>

        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginBlock: '0.3rem',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              paddingLeft: '15px',
              fontWeight: '600',
              color: 'rgb(96, 96, 96)',
            }}
          >
            Reference Window
          </Typography>
          <Tooltip
            title="Reset reference window to default"
            placement="top"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
          >
            <ReplayIcon
              sx={{ fontSize: '14px', marginLeft: '5px', cursor: 'pointer' }}
              onClick={resetWindowFunction}
            />
          </Tooltip>
        </Typography>
        <div
          className="slidingRefWindow"
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '15px',
              marginLeft: '4px',
            }}
          >
            <Checkbox
              checked
              disabled
              size="small"
              sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
            />
            <Select
              labelId="prev-next-curr-1"
              id="first-dropdown"
              value={dropdownSelections.first}
              onChange={handleChange}
              name="first"
              sx={{ ...dropDownSelectStyle, minWidth: '100px', marginRight: '9px' }}
            >
              {dropDownOptions.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  disabled={
                    option === 'Current' && needSecondRef && dropdownSelections.second === 'Current'
                  }
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
            {dropdownSelections.first !== 'Current' && !isCustomSelected.first && (
              <Select
                labelId="prev-next-curr-1"
                id="first-dropdown"
                value={`${Math.abs(windowFnValues.slidingPreInc)}`}
                onChange={handleDropdownChangeForRow}
                name="first"
                sx={{ ...dropDownSelectStyle, minWidth: '60px' }}
              >
                {values.map((option) => (
                  <MenuItem key={option.label} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            )}
            {dropdownSelections.first !== 'Current' && isCustomSelected.first && (
              <TextField
                type="number"
                value={Math.abs(Number(inputs.first))}
                name="first"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                  input: { style: { height: '25px' } },
                  htmlInput: { min: 0, max: 100 },
                }}
                sx={{
                  width: '95%',
                  '& .MuiInputBase-root': {
                    height: '2rem',
                    fontSize: '11px',
                  },
                  '& .MuiTextField-root': {
                    outline: 'none',
                    border: 'none',
                  },
                  border: 'none',
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#2bb9bb',
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '16.5px 14px', // Consistent padding for all browsers
                  },
                  // Firefox-specific styling
                  '@supports (-moz-appearance: none)': {
                    '& .MuiOutlinedInput-input': {
                      padding: '16.5px 2px 16.5px 14px',
                    },
                  },
                }}
                onBlur={handleInputChange}
                onChange={onInputChange}
              />
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '15px',
              marginLeft: '4px',
            }}
          >
            <Checkbox
              checked={needSecondRef}
              onChange={handleNeedOFSecondRefChange}
              size="small"
              sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
            />

            <Select
              disabled={!needSecondRef}
              labelId="prev-next-curr-2"
              id="second-dropdown"
              value={dropdownSelections.second}
              onChange={handleChange}
              name="second"
              sx={{ ...dropDownSelectStyle, minWidth: '100px', marginRight: '9px' }}
            >
              {dropDownOptions.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  disabled={
                    option === 'Current' && needSecondRef && dropdownSelections.first === 'Current'
                  }
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
            {dropdownSelections.second !== 'Current' && !isCustomSelected.second && (
              <Select
                disabled={!needSecondRef}
                labelId="prev-next-curr-2"
                id="second-dropdown"
                value={`${Math.abs(windowFnValues?.slidingNextInc ?? 999)}`}
                onChange={handleDropdownChangeForRow}
                name="second"
                sx={{ ...dropDownSelectStyle, minWidth: '60px' }}
              >
                {values.map((option) => (
                  <MenuItem key={option.label} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            )}
            {dropdownSelections.second !== 'Current' && isCustomSelected.second && (
              <TextField
                disabled={!needSecondRef}
                type="number"
                value={Math.abs(Number(inputs.second))}
                name="second"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                  input: { style: { height: '25px' } },
                  htmlInput: { min: 1, max: 100 },
                }}
                sx={{
                  width: '95%',
                  '& .MuiInputBase-root': {
                    height: '2rem',
                    fontSize: '11px',
                  },
                  '& .MuiTextField-root': {
                    outline: 'none',
                    border: 'none',
                  },
                  border: 'none',
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#2bb9bb',
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '16.5px 14px', // Consistent padding for all browsers
                  },
                  // Firefox-specific styling
                  '@supports (-moz-appearance: none)': {
                    '& .MuiOutlinedInput-input': {
                      padding: '16.5px 2px 16.5px 14px',
                    },
                  },
                }}
                onChange={onInputChange}
                onBlur={handleInputChange}
              />
            )}
          </Box>
        </div>

        <Typography
          sx={{
            fontSize: '12px',
            paddingLeft: '15px',
            fontWeight: '600',
            color: 'rgb(96, 96, 96)',
            marginTop: '2px',
          }}
        >
          Aggregation
        </Typography>

        <FormControl fullWidth>
          <Select
            onChange={(e) =>
              setWindowFnValues((prevState: any) => ({
                ...prevState,
                slidingAggregation: e.target.value,
              }))
            }
            value={windowFnValues.slidingAggregation}
            sx={{ ...dropDownSelectStyle, margin: '3px 15px 7px 15px', minWidth: '192px' }}
          >
            {slidingAggregation.map((data, index) => (
              <MenuItem key={index} value={data} sx={{ fontSize: '12px' }}>
                {data}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default SlidingOptions;
